module.exports = __webpack_public_path__ + "img/mowerwalk_stopped.deca936a.svg";